import { FormValidator } from '../../utils';

export class MeetingsValidator extends FormValidator {
  // Phone Number field validator
  cellPhone(validator) {
    validator.isRequired();
    validator.isValidPhoneNumber();
  }
}
